import { createFileRoute } from '@tanstack/react-router'

import { validateListSearch } from '#/shared/lib/list-search'

import { AiRatesPage } from '#/modules/ai-costs'

export const Route = createFileRoute('/_shell/ai-rates/')({
  component: AiRatesPage,
  validateSearch: validateListSearch,
})
